import Vue from 'vue'
import store from 'store'

export default el => Promise.all([
  enqueueModule('product-card-slider.vue')
]).then(() => new Vue({ el, store }))
